import { render, staticRenderFns } from "./SessionGridItem.vue?vue&type=template&id=2ce7a3c2&scoped=true"
import script from "./SessionGridItem.vue?vue&type=script&lang=js"
export * from "./SessionGridItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce7a3c2",
  null
  
)

export default component.exports